export default class ServerUtils {

  static getVersion() {
    return "1.0.91";
  }

  // All production file downloads go through the same host.
  static fileSystemDownloadEndpoint() {
    return "/";
  }

  // API requests go through NGINX -> Node :3002
  static apiEndpoint() {
    return "/";
  }

  static getUserImageUrl(user) {
    if (user && user.imageUrl && user.imageUrl.length > 0) {
      return `/data/public/images/avatars/users/${user.imageUrl}`;
    }

    return "";
  }

  static getUserBannerUrl(user) {
    if (user && user.bannerUrl && user.bannerUrl.length > 0) {
      if (user.bannerUrl.includes("http")) {
        return user.bannerUrl;
      }

      return `/data/public/images/banners/users/${user.bannerUrl}`;
    }

    return "/img/default-banner.jpg";
  }

  static getPostImageUrl(post) {
    if (post && post.imageUrl && post.imageUrl.length > 0) {
      if (post.imageUrl.includes("http")) {
        return post.imageUrl;
      }

      return `/data/public/images/posts/blog/${post.imageUrl}`;
    }

    return "";
  }

  static async POST(url, body) {
    return new Promise((resolve, reject) => {
      fetch(this.apiEndpoint() + url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      })
        .then((response) => resolve(response.json()))
        .catch((error) => {
          console.error("POST error: ", error);
          reject(error);
        });
    });
  }

  static async GET(url) {
    return new Promise((resolve, reject) => {
      fetch(this.apiEndpoint() + url, {
        credentials: 'include',
      })
        .then((response) => resolve(response.json()))
        .catch((error) => {
          console.error("GET error: ", error);
          reject(error);
        });
    });
  }

  static async sendMessage(msg) {
    return this.POST('api/messages/send', { message: msg });
  }

  static async deleteMessage(msg) {
    return this.POST('api/messages/delete', { message: msg });
  }

  static async unlockRequest(password) {
    return this.POST('unlock', { password });
  }

  static async recentEventsSummary() {
    return this.GET('api/reports/recent-events-summary');
  }
}